<template>
  <Popper :hover="true" :placement="'top-start'">
    <template v-if="showTooltip" #content>
      <div
        class="req-text-container d-flex align-items-center p-2"
        :class="[bgColor, justify, width]"
      >
        <p class="req-text" :class="textClass">
          <slot name="content"> </slot>
        </p>
      </div>
    </template>
    <slot></slot>
  </Popper>
</template>

<script setup lang="ts">
import Popper from "vue3-popper";
import { withDefaults, defineProps } from "vue";

type GrTooltipProps = {
  showTooltip?: boolean;
  bgColor?: string;
  textClass?: string;
  justify?: string;
  width: "large" | "medium" | "small";
};

withDefaults(defineProps<GrTooltipProps>(), {
  showTooltip: true,
  bgColor: "",
  textClass: "text-tiny",
  justify: "",
  width: "large"
});
</script>

<style scoped>
.large {
  max-width: 30rem;
}

.medium {
  max-width: 20rem;
}

.small {
  max-width: 12rem;
}

.req-text-container {
  min-height: 2.4rem;
  transition: opacity 0.2s;
  background-color: rgb(255, 255, 255);
  border-radius: 4px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
}

.req-text {
  max-width: 100%;
  white-space: normal;
}
</style>
